module.exports = __webpack_public_path__ + "infocentrum8.jpg?9c8d843557d7d9dba286bff1ac7c9437";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/infocentrum/infocentrum8.jpg
// module id = 260
// module chunks = 0